import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { brocktonConfig } from "./data";

export default function BrocktonPage() {
  return <CityPageTemplate config={brocktonConfig} />;
}